import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            score: 0,
            comment: '',
            isActive: false,
            demand: { id: 0 },
            person: { id: 0 }
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};


// WEBPACK FOOTER //
// ./src/helpers/entities/Evaluation.js